"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import React from "react";
export default function CalendarArrow(props) {
  const $ = _c(7);
  const t0 = `flex cursor-pointer h-12 rounded-full  select-none  w-full ${props.isLeft ? "" : "justify-end"}`;
  const t1 = props.isLeft ? "/icons/arrow-left.svg" : "/icons/arrow-right.svg";
  const t2 = props.isLeft ? "Mois pr\xE9c\xE9dent" : "Mois suivant";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <Image width={10} height={10} src={t1} alt={t2} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props.onClick || $[4] !== t0 || $[5] !== t3) {
    t4 = <div className={t0} onClick={props.onClick}>{t3}</div>;
    $[3] = props.onClick;
    $[4] = t0;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}